import DebtInvoicesContainer from "containers/debt-invoices/debt-invoices-container";

function CompanyDashboard() {
  return <DebtInvoicesContainer />;
}

export default CompanyDashboard;
